import { Typography, Stack, Chip, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import IconAvatar from "../atoms/IconAvatar";
import { Task, Timelog } from "../../services/swagger";
import { formatMilliseconds } from "../../helpers/date";

interface TaskTimelogChipProps {
  task: Task;
  timelog: Timelog;
  onClick?: () => void;
  onDelete: () => void;
}

export default function TimelogChip(props: TaskTimelogChipProps) {
  const { t } = useTranslation("TaskTimelogChip");

  const { task, timelog, onClick, onDelete } = props;

  const start = new Date(
    Math.round(timelog.startDate / 60000) * 60000
  ).toLocaleString("tr");
  const end = timelog.endDate
    ? new Date(Math.round(timelog.endDate / 60000) * 60000).toLocaleString("tr")
    : "...";
  const duration =
    timelog.endDate && timelog.startDate
      ? formatMilliseconds(
          Math.max(
            60000,
            Math.round((timelog.endDate - timelog.startDate) / 60000) * 60000
          )
        )
      : t("InProgress");

  return (
    <Chip
      variant="filled"
      onDelete={!task.cancelled ? onDelete : undefined}
      onClick={!task.cancelled ? onClick : undefined}
      deleteIcon={
        !task.cancelled ? <IconAvatar icon={CloseIcon} size={18} /> : undefined
      }
      label={
        <Box
          sx={{
            textAlign: "left",
            whiteSpace: "pre-line",
            width: 1,
            display: "block",
          }}
        >
          <Typography variant="body2">
            <strong>{t("StartTime")}:</strong> {start}
          </Typography>
          <Typography variant="body2">
            <strong>{t("EndTime")}:</strong> {end}
          </Typography>
          <Typography variant="body2">
            <strong>{t("Duration")}:</strong> {duration}
          </Typography>
        </Box>
      }
      sx={{
        height: "auto !important",
        width: 1,
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "left",
        backgroundColor: "background.paper",
        borderRadius: 1,
        pt: 1,
        pb: 1,
        pr: 1,
        opacity: task.cancelled ? 0.6 : 1,
        pointerEvents: task.cancelled ? "none" : "auto",
      }}
    />
  );
}
